import React from "react";
import { motion } from "framer-motion";
import Breadcrumbs from "@/components/common/Breadcrumbs";
import { RouteLines } from "@/components/common/RouteLines";

// Internal page hero with eyebrow, H1, intro and breadcrumbs.
export default function PageHero({ eyebrow, title, intro, breadcrumbs = [], children }) {
  return (
    <section className="relative bg-navy text-white overflow-hidden" data-testid="page-hero">
      <RouteLines className="pointer-events-none absolute inset-0 h-full w-full opacity-20" stroke="#4FD1CA" opacity={0.6} />
      <div className="relative">
        {breadcrumbs.length > 0 && (
          <div className="[&_a]:text-white/60 [&_span]:text-white [&_.text-muted-foreground]:text-white/50">
            <Breadcrumbs items={breadcrumbs} />
          </div>
        )}
        <div className="container-page pt-8 pb-16 lg:pt-10 lg:pb-24 max-w-4xl">
          {eyebrow && (
            <motion.p
              initial={{ opacity: 0, y: 12 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
              className="inline-flex items-center gap-2 text-[12px] font-semibold uppercase tracking-[0.18em] text-copper mb-5"
            >
              <span className="h-px w-8 bg-copper" /> {eyebrow}
            </motion.p>
          )}
          <motion.h1
            initial={{ opacity: 0, y: 18 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.05, ease: [0.22, 1, 0.36, 1] }}
            className="font-heading font-bold tracking-tight text-[36px] leading-[42px] md:text-[48px] md:leading-[56px] lg:text-[54px] lg:leading-[62px]"
          >
            {title}
          </motion.h1>
          {intro && (
            <motion.p
              initial={{ opacity: 0, y: 18 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7, delay: 0.12 }}
              className="mt-6 text-[18px] leading-[29px] lg:text-[20px] lg:leading-[32px] text-white/75 max-w-2xl"
            >
              {intro}
            </motion.p>
          )}
          {children && <div className="mt-8">{children}</div>}
        </div>
      </div>
    </section>
  );
}
